module.exports = __webpack_public_path__ + "img/fondo-home.6e64549e.png";